/**
 * Neat way to get a rendered html text in DOM without actually mount it
 */
export const decodeHtmlEntities = (text: string) => {
    if (!document) return text;

    const element = document.createElement("div");
    element.innerHTML = text;
    return element.textContent || "";
};
